import { useEffect } from "react";

export function signInURL(
  returnTo = window.location.pathname + window.location.search + window.location.hash,
) {
  return `/auth/login?return_to=${encodeURIComponent(returnTo)}`;
}
export function freshSignInURL() {
  return `/auth/login?fresh=1&return_to=${encodeURIComponent(window.location.pathname + window.location.search + window.location.hash)}`;
}
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = `${title} · SSBD Access`;
  }, [title]);
}
